import { Divider, Stack } from '@mui/material';
import { useState } from 'react';

import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { uploadStatementFiles } from 'portal/src/api/StatementsService';
import useAuth from 'portal/src/auth/useAuth';
import FileUploader from 'portal/src/components/billAutomation/forms/FileUploader';

import FileUploadPreviewDialog from './dialogs/FileUploadPreviewDialog/FileUploadPreviewDialog';
import useImgPreviewSrc from './FileUploadDetails/useImgPreviewSrc';
import UploadHistoryTable from './UploadHistoryTable/UploadHistoryTable';

const BillUpload = () => {
  const { hasSystemAdminAccess } = useAuth();
  const isSysAdmin = hasSystemAdminAccess();

  const [showPicPreview, setShowPicPreview] = useState<string | null>(null);

  const { previewSrc, isFetchingImg, isPdf } = useImgPreviewSrc(showPicPreview);

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      marginInline={2}
      pt={3}
    >
      <FileUploader
        fileTypeCategory="billUpload"
        uploadHandlers={{
          uploadFiles: async (files) => uploadStatementFiles({ files }),
        }}
        refetchKey="statements"
        promptMessage={
          'Each file must only contain one bill or a consolidated' +
          ' bill for a single utility.'
        }
      />
      <Divider sx={{ mt: 4, mb: 2 }}>Bill Upload History</Divider>
      <UploadHistoryTable
        contextName={NESTED_ROUTES.BILL_AUTOMATION.BILL_UPLOAD}
        isSysAdmin={isSysAdmin}
        variant="bill"
        setShowPicPreview={setShowPicPreview}
      />
      <FileUploadPreviewDialog
        open={!!showPicPreview}
        onClose={() => setShowPicPreview(null)}
        previewSrc={previewSrc}
        isPdf={isPdf}
        isFetchingImg={isFetchingImg}
      />
    </Stack>
  );
};

export default BillUpload;
